import React, { Component } from "react";

import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
} from "reactstrap";

import event_24 from "../../assets/img/event_guide/24.jpg";
import event_25 from "../../assets/img/event_guide/25.jpg";
import event_26 from "../../assets/img/event_guide/26.jpg";
import event_26_1 from "../../assets/img/event_guide/26-1.jpg";
import event_27 from "../../assets/img/event_guide/27.jpg";
import event_27_2 from "../../assets/img/event_guide/27-2.jpg";
import event_31 from "../../assets/img/event_guide/31.jpg";
import event_1 from "../../assets/img/event_guide/1.jpg";
import event_3 from "../../assets/img/event_guide/3.jpg";

const items = [
  {
    src: event_24,
  },
  {
    src: event_25,
  },
  {
    src: event_26,
  },
  {
    src: event_26_1,
  },
  {
    src: event_27,
  },
  {
    src: event_27_2,
  },
  {
    src: event_31,
  },
  {
    src: event_1,
  },
  {
    src: event_3,
  },
];

class EventCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: 0 };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex =
      this.state.activeIndex === items.length - 1
        ? 0
        : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous() {
    if (this.animating) return;
    const nextIndex =
      this.state.activeIndex === 0
        ? items.length - 1
        : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }

  render() {
    const { activeIndex } = this.state;

    const slides = items.map((item) => {
      return (
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item.src}
        >
          <img
            src={item.src}
            alt="carousel item"
            style={{ width: "100%", maxHeight: "1800px", objectFit: "cover" }}
          />
        </CarouselItem>
      );
    });

    return (
      <Carousel
        activeIndex={activeIndex}
        next={this.next}
        previous={this.previous}
      >
        <CarouselIndicators
          items={items}
          activeIndex={activeIndex}
          onClickHandler={this.goToIndex}
        />
        {slides}
        <CarouselControl
          direction="prev"
          directionText="Previous"
          onClickHandler={this.previous}
        />
        <CarouselControl
          direction="next"
          directionText="Next"
          onClickHandler={this.next}
        />
      </Carousel>
    );
  }
}

export default EventCarousel;
